import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FreshnessMeter from "./FreshnessMeter";
import { FreshnessDetailModalProps } from "../../types";

const formatKey = (key: string): string =>
  key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const formatValue = (value: any): string => {
  if (Array.isArray(value)) {
    return value.length === 0 ? "Not Available" : value.join(", ");
  }
  if (typeof value === "boolean") {
    return value ? "True" : "False";
  }
  return String(value);
};

export default function FreshnessDetailModal({
  open,
  onClose,
  position,
  details,
}: FreshnessDetailModalProps) {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: "300px",
          maxHeight: "calc(var(--app-vh, 1vh) * 80)",
          minWidth: "350px",
          maxWidth: "40vw",
          m: 1,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{ p: 0, m: 0, display: "flex", justifyContent: "flex-end" }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box display={"flex"} flexDirection={"column"} gap={3}>
          <Box display={"flex"} justifyContent={"center"}>
            <FreshnessMeter position={position} isModal={true} />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              gap: 1,
            }}
          >
            <Typography fontWeight={"bold"}>
              FREXHO Meter<sup>™</sup>: {details?.freshness}
            </Typography>

            <Typography fontWeight={"bold"} variant="body2">
              Product:{" "}
              <Typography display={"inline"} variant="body2">
                {details?.product}
              </Typography>
            </Typography>

            <Typography fontWeight={"bold"} variant="body2">
              Location:{" "}
              <Typography display={"inline"} variant="body2">
                {details?.locationName} [{Number(details?.longitude).toFixed(2)}
                , {Number(details?.latitude).toFixed(2)}]
              </Typography>
            </Typography>

            <Typography fontWeight={"bold"} variant="body2">
              Explanation:{" "}
              <Typography display={"inline"} variant="body2">
                {" "}
                {details?.explanation}{" "}
              </Typography>
            </Typography>

            {Object.entries(details?.score ?? {}).map(([key, value]) => (
              <Typography key={key} variant="body2" sx={{ mb: 1 }}>
                <strong>{formatKey(key)}</strong>: {formatValue(value)}
              </Typography>
            ))}
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "text.secondary",
                fontSize: "0.7rem",
              }}
            >
              Our model focuses on several characteristics traditionally used by
              fishermen to assess fish freshness, including eyes, skin texture, gills,
              and scales.
            </Typography>

            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "text.secondary",
                fontSize: "0.7rem",
              }}
            >
              Quality assessment by FREXHO Meter<sup>™</sup> &mdash; Patented AI
              technology by TRALEXHO<sup>®</sup>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
